import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 20,
  },
  pageTitle: {
    fontSize: theme.typography.h6.fontSize,
  },
  dividerTitle: {
    marginBottom: theme.spacing(2),
  },
  titleCampo: {
    fontSize: theme.typography.h6.fontSize,
    marginTop: theme.spacing(2),
  },
  item: {
    padding: theme.spacing(1),
  },
}))

export default useStyles
